import { render, staticRenderFns } from "./UploadNow.vue?vue&type=template&id=667c75d3&scoped=true"
import script from "./UploadNow.vue?vue&type=script&lang=ts"
export * from "./UploadNow.vue?vue&type=script&lang=ts"
import style0 from "./UploadNow.vue?vue&type=style&index=0&id=667c75d3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c75d3",
  null
  
)

export default component.exports